/**
 * What a path that is not a link at all renders.
 *
 * It was nearly unreachable before: the only route was `/v2/scan`, so anything else on this origin
 * was a mistake somebody had to make on purpose. Now that the credential IS the path
 * (docs/decisions.md D-41) this page is the ordinary answer to ordinary traffic - a crawler asking
 * for `/robots.txt`, a browser asking for `/favicon.ico` without being told to, a patient who
 * mistyped. It is deliberately the same page for all of them, and deliberately NOT the dead-link
 * screen: "this link no longer works" is a claim about a link, and none of these was one.
 *
 * **It is the one patient-facing sentence in this app that is not translated, and that is a limit
 * rather than an oversight.** The scan surface localises from the token (architecture §9): the
 * language arrives on the scan config, which is fetched with an access token, which requires a
 * credential. This page is what renders when there is no credential, so there is nothing to ask.
 * That is also why it says as little as possible - one sentence a reader can act on without being
 * told anything about scans, grants or codes they do not have.
 */
export function NotFoundPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 p-4">
      <p className="text-sm text-slate-600">Page not found.</p>
    </div>
  )
}
